"use client"

import { useState, useEffect, useRef } from "react"
import "./CareerWorking.css"
import { FaCode, FaUsers, FaChartLine, FaCogs } from "react-icons/fa" // Replace or add icons as needed

const tabs = [
  { key: "engineering", title: "REMOTE FIRST", icon:<img src="/icons/icon1.svg" alt="Engineering" /> },
  { key: "team", title: "INTERNATIONAL PROJECTS", icon: <img src="/icons/icon2.svg" alt="Engineering" />  },
  { key: "growth", title: "FLEXIBLE WORKING HOURS", icon: <img src="/icons/icon3.svg" alt="Engineering" /> },
  { key: "operations", title: "TEAM EVENTS", icon: <img src="/icons/icon4.svg" alt="Engineering" />  },
  { key: "career", title: "CAREER PLAN", icon: <img src="/icons/icon5.svg" alt="Engineering" />  },
  { key: "informal", title: "INFORMAL ENVIRONMENT", icon: <img src="/icons/icon6.svg" alt="Engineering" />  },
]

const tabContents = {
  engineering: [
    {
      title: "REMOTE FIRST",
      description: "Working from home or the office is up to you."
    },
    
  ],
  team: [
    {
      title: "INTERNATIONAL PROJECTS",
      description: "Get your hands on projects for innovative companies around the world."
    },
    
  ],
  growth: [
    {
      title: "FLEXIBLE WORKING HOURS",
      description: "Adapt the schedule to your daily routine."
    },
    
  ],
  operations: [
    {
      title: "TEAM EVENTS",
      description: "Together, we grow. Let's share our knowledge and celebrate collectively."
    },
   
  ],
   career :[
    {
      title: "CAREER PLAN",
      description: "We offer a permanent contract, mentoring with monthly one-on-ones, and performance feedback."
    },
   
  ],
   informal: [
    {
      title: "INFORMAL ENVIRONMENT",
      description: "We are more creative and productive in a relaxed and inclusive atmosphere."
    },
   
  ],
}

const CareerWorking = () => {
  const [activeTab, setActiveTab] = useState("engineering")
  const progressBarRef = useRef(null)

  useEffect(() => {
    const total = tabs.length
    const index = tabs.findIndex(tab => tab.key === activeTab)
    const progress = ((index + 1) / total) * 100
    if (progressBarRef.current) {
      progressBarRef.current.style.width = `${progress}%`
    }
  }, [activeTab])

  return (
    <section className="career-working-section" id="perks">
      <div className="container">
     <div className="career-working-title"><h2 >WHY YOU WILL LOVE <br/> <span className="blue-text">WORKING HERE</span></h2></div>
       
      <div className="career-card">
        {/* Tab Bar */}
        <div className="tab1-bar">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`tab1-btn ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <div className="tab1-icon">{tab.icon}</div>
              <div className="tab1-title">{tab.title}</div>
            </button>
          ))}
          <div className="tab1-progress">
            <div className="tab-progress-bar" ref={progressBarRef}></div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab1-content">
          {tabContents[activeTab].map((item, index) => (
            <div key={index} className="content-card">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  )
}

export default CareerWorking
